import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import Transferable, { TransferEventListener } from '@philips-emr/tws-core//lib/component/types/transferable';

class FileUploaderAPI extends ComponentAPI implements Transferable {

  /** @event */
  @AwesomeEvent
  onUpload = new TransferEventListener();

  /** @event */
  @AwesomeEvent
  onRetry = new TransferEventListener();

  /** @event */
  @AwesomeEvent
  onPreview = new TransferEventListener();

  /** @event */
  @AwesomeEvent
  onRemove = new TransferEventListener();

  /** @event */
  @AwesomeEvent
  onAbort = new TransferEventListener();

  /** @event */
  @AwesomeEvent
  onError = new TransferEventListener();

  /** @event */
  @AwesomeEvent
  onCompleted = new TransferEventListener();

  getSelectFileExpression(): string {
    return this.state.selectFileExpression;
  }

  setSelectFileExpression(selectFileExpression: string): void {
    this.setState({ selectFileExpression });
  }

  getCancelUploadExpression(): string {
    return this.state.cancelUploadExpression;
  }

  setCancelUploadExpression(cancelUploadExpression: string): void {
    this.setState({ cancelUploadExpression });
  }

  getPreviewFileExpression(): string {
    return this.state.previewFileExpression;
  }

  setPreviewFileExpression(previewFileExpression: string): void {
    this.setState({ previewFileExpression });
  }

  getRetryUploadExpression(): string {
    return this.state.retryUploadExpression;
  }

  setRetryUploadExpression(retryUploadExpression: string): void {
    this.setState({ retryUploadExpression });
  }

  getFailedUploadExpression(): string {
    return this.state.failedUploadExpression;
  }

  setFailedUploadExpression(failedUploadExpression: string): void {
    this.setState({ failedUploadExpression });
  }
}

export default FileUploaderAPI;
